import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Multiline } from './va-multiline';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  styleUrls: ['./va-multiline.component.scss'],
  template: `
    @if (!config.link) {
      <span class="title">{{ config.title }}</span>
    } @else {
      @if (config?.link?.external) {
        <a [routerLink]="$safeNavigationMigration(config?.link?.url)" [target]="$safeNavigationMigration(config?.link?.target)" class="title">
          <span>{{ config.title }}</span>
        </a>
      }
      @if (!config?.link?.external) {
        <a
          [routerLink]="$safeNavigationMigration(config?.link?.url)"
          [queryParams]="$safeNavigationMigration(config?.link?.queryParams)"
          [target]="$safeNavigationMigration(config?.link?.target)"
          class="title"
          >
          <span>{{ config.title }}</span>
        </a>
      }
    }
    @if (config?.subtitle) {
      <span
        class="subtitle"
        [style.color]="config?.description ? 'rgba(0,0,0,0.87)' : 'rgba(0,0,0,0.54)'"
        >
        {{ config?.subtitle }}
      </span>
    }
    @if (config?.description) {
      <span class="description">{{ config?.description }}</span>
    }
    `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, RouterModule],
})
export class VaMultilineComponent {
  @Input() config: Multiline;
}
